import { ModalContentSurface, ModalDialog } from '@components'
import cn from '@integrations/classnames'
import { tr, useGlobalMaintenanceMode } from 'mmfintech-commons'
import styles from './MaintenanceModal.module.scss'

function MaintenanceModal() {
  const isMaintenanceMode = useGlobalMaintenanceMode()

  return isMaintenanceMode ? (
    <ModalDialog
      content={
        <ModalContentSurface
          size='wide'
          className={cn(styles['maintenance-modal-wrapper'], 'maintenance-modal-wrapper')}
        >
          <div className={cn(styles['heading'], 'heading')}>{tr('FRONTEND.MAINTENANCE.HEADING', 'Maintenance')}</div>
          {tr(
            'FRONTEND.MAINTENANCE.BODY',
            'We are currently performing scheduled maintenance. Please check back shortly. We apologize for any inconvenience.'
          )}
        </ModalContentSurface>
      }
      options={{
        closeOnClickOutside: false,
        closeOnEscape: false,
        hideCloseIcon: true
      }}
      visible={true}
      onClose={() => {}}
    />
  ) : null
}

export default MaintenanceModal
